<template>
  <div
    class="contant d-flex flex-column align-center"
    :class="{ mobile: isMobile }"
  >
    <div class="d-flex flex-column">
      <div class="left">
        <div class="topInfo">
          <a href="/" class="logo-link">
            <img
              src="@/assets/metro_logo.png"
              height="200"
              class="logoUrl"
              alt="Metro logo"
            />
          </a>

          <h1 class="des mt-7">Your Web3 Travel Companion</h1>
          <p class="des1 mt-4">
            Earn rewards, enjoy exclusive perks, and upgrade your daily commute.
          </p>

          <div class="download mt-8">
            <div class="download d-flex flex-row">
              <a
                class="store-link"
                href="https://file.uptick.network/app/Metro.apk"
                target="_blank"
                rel="noopener noreferrer"
                @mouseenter="mousedAndroid"
                @mouseleave="leaveAndroid"
              >
                <img
                  src="@/assets/d_android.png"
                  :height="isMobile ? 60 : 50"
                  alt="Download Metro for Android"
                />
              </a>

              <a
                class="store-link ml-6"
                href="https://play.google.com/store/apps/details?id=com.grandmetroclub.metro"
                target="_blank"
                rel="noopener noreferrer"
                @mouseenter="mousedGoogle"
                @mouseleave="leaveGoogle"
              >
                <img
                  src="@/assets/d_googleplay.png"
                  class="testflight"
                  :height="isMobile ? 60 : 50"
                  alt="Get Metro on Google Play"
                />
              </a>
            </div>

            <img
              v-if="isShowAndroid && !isMobile"
              class="android_code"
              src="@/assets/Metro_android.png"
              width="185"
              alt="Metro Android download QR code"
            />
            <img
              v-if="isShowFGoogle && !isMobile"
              class="google_code"
              src="@/assets/Metro_Googleplay.png"
              width="185"
              alt="Metro Google Play download QR code"
            />
          </div>
        </div>
        <div class="Lifestyle" id="lifestyle">
          <img src="@/assets/image01.png" class="lifeImage" alt="Metro Web3 travel lifestyle" loading="lazy" decoding="async" />
          <div class="lifeinfo">
            <h2 class="text-30 mb-3" style="color: #141e3a">
              Web3 Travel, On Demand
            </h2>
            <img src="@/assets/image02.png" class="lifeImage1" alt="Metro local connections and rewards" loading="lazy" decoding="async" />
            <div class="text-30 mt-2" style="color: #6168e0">
              Tap In. Explore Local Connections. Get Rewarded
            </div>
          </div>
        </div>
        <div class="TokenInfo" id="ecosystem">
          <div class="Urban">
            <h2 class="text-30" style="color: #141e3a">
              Redefining City Travel with Web3
            </h2>
            <div class="text-18 mt-8">
              Join the Metro membership club of the future, where eco-friendly
              rides turn into real rewards. Earn tokenized incentives every time
              you take the Metro, turning your commute into a value-driven
              experience.
            </div>
            <div class="text-18 mt-5">
              The Metro app connects travel, local businesses, and lifestyle
              services into a frictionless, token-powered ecosystem, creating
              real-world utility for every ride.
            </div>
          </div>
          <img src="@/assets/image03.png" class="footImage1" alt="Metro city travel Web3 ecosystem" loading="lazy" decoding="async" />
        </div>
        <div class="Companion" id="features">
          <h2 class="text-35">Your Ultimate Metro Travel Companion</h2>
          <div class="CompanionType">
            <div class="itemLeft">
              <h3 class="text-30" style="color: #141e3a">
                Metro Journey Assistance
              </h3>
              <div class="text-18 metroText mt-5" style="color: #141e3a">
                Get real-time metro info, route planning, and travel support at
                your fingertips.
              </div>
            </div>
            <div class="itemRight">
              <img src="@/assets/image04.png" class="footImage" alt="Metro journey assistance feature" loading="lazy" decoding="async" />
            </div>
          </div>

          <div class="CompanionType">
            <div class="itemLeft" v-if="!isMobile">
              <img src="@/assets/image05.png" class="footImage" alt="Metro nearby merchant connections" loading="lazy" decoding="async" />
            </div>
            <div class="itemRight">
              <h3 class="text-30" style="color: #141e3a">
                Nearby Merchant Connections
              </h3>
              <div class="text-18 metroText mt-5" style="color: #141e3a">
                Find exclusive deals at local businesses near your metro stops.
              </div>
            </div>
            <div class="itemLeft" v-if="isMobile">
              <img src="@/assets/image05.png" class="footImage" alt="Metro nearby merchant connections" loading="lazy" decoding="async" />
            </div>
          </div>

          <div class="CompanionType">
            <div class="itemLeft">
              <h3 class="text-30" style="color: #141e3a">Ride to Earn</h3>
              <div class="text-18 metroText mt-5" style="color: #141e3a">
                Join the Metro Club and earn rewards every time you travel.
              </div>
            </div>
            <div class="itemRight">
              <img src="@/assets/image06.png" class="footImage" alt="Metro Ride to Earn rewards" loading="lazy" decoding="async" />
            </div>
          </div>

          <div class="CompanionType">
            <div class="itemLeft" v-if="!isMobile">
              <img src="@/assets/image07.png" class="footImage" alt="Metro in-app campaigns" loading="lazy" decoding="async" />
            </div>
            <div class="itemRight">
              <h3 class="text-30" style="color: #141e3a">
                Exclusive In-App Campaigns
              </h3>
              <div class="text-18 metroText mt-5" style="color: #141e3a">
                Make every ride more rewarding. Join Metro’s interactive
                promotions and activities to earn perks while you travel.
              </div>
            </div>
            <div class="itemLeft" v-if="isMobile">
              <img src="@/assets/image07.png" class="footImage" alt="Metro in-app campaigns" loading="lazy" decoding="async" />
            </div>
          </div>
        <div class="Faq" id="faq">
          <h2 class="text-35" style="color:#141e3a">Frequently Asked Questions</h2>
          <div class="faqList mt-8">
            <div class="faqItem mt-6">
              <h3 class="text-30" style="color:#141e3a">What is Metro?</h3>
              <div class="text-18 metroText mt-3" style="color:#141e3a">Metro is a Web3 travel companion app that turns your daily metro commute into tokenized rewards, local merchant perks, and a more eco-friendly urban lifestyle.</div>
            </div>
            <div class="faqItem mt-6">
              <h3 class="text-30" style="color:#141e3a">How do I earn rewards with Metro?</h3>
              <div class="text-18 metroText mt-3" style="color:#141e3a">Simply ride the metro and check in through the app. Every trip converts into tokenized incentives you can redeem for perks across the Metro ecosystem.</div>
            </div>
            <div class="faqItem mt-6">
              <h3 class="text-30" style="color:#141e3a">Which cities does Metro support?</h3>
              <div class="text-18 metroText mt-3" style="color:#141e3a">Metro is expanding across major metropolitan areas. Download the app to see the latest supported cities and merchant networks near you.</div>
            </div>
            <div class="faqItem mt-6">
              <h3 class="text-30" style="color:#141e3a">Is Metro free to use?</h3>
              <div class="text-18 metroText mt-3" style="color:#141e3a">Yes. The Metro app is free to download and join. Rewards and perks are earned by riding and engaging with the ecosystem.</div>
            </div>
            <div class="faqItem mt-6">
              <h3 class="text-30" style="color:#141e3a">Where can I download Metro?</h3>
              <div class="text-18 metroText mt-3" style="color:#141e3a">Metro is available on Google Play and as an Android APK. Scan the QR codes on this page or tap the store buttons to get started.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  data: function () {
    return {
      isShowAndroid: false,
      isShowFGoogle: false,
    };
  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  methods: {
    mousedAndroid() {
      this.isShowAndroid = true;
    },
    leaveAndroid() {
      this.isShowAndroid = false;
    },
    mousedGoogle() {
      this.isShowFGoogle = true;
    },
    leaveGoogle() {
      this.isShowFGoogle = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.contant {
  width: 100%;
  height: 100%;
  h1,
  h2,
  h3 {
    margin: 0;
  }
  .highLight {
    margin: -30px 0px 25px !important;
  }
  .footImage1 {
    width: 45%;
  }
  .footImage {
    width: 90%;
  }
  .footerInfo {
    margin: 110px 0px 25px;
    .title-25 {
      font-family: Helvetica;
      font-size: 30px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 32px;
      color: #d4b07b;
    }
    .title-16 {
      font-family: Helvetica;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 30px;
      color: #d4b07b;
      span {
        font-weight: bold;
      }
    }
    .title-20 {
      font-family: Helvetica;
      font-size: 21px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 32px;
      color: #d4b07b;
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .topInfo {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-image: url('@/assets/image_bg.jpg');
      background-size: cover;
      min-height: 600px;
      .logo-link {
        display: inline-block;
        line-height: 0;
      }
    }
    .Lifestyle {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 530px;
      padding: 0 15%;
      // padding-left: 18%;
      .lifeImage {
        width: 50%;
      }
      .lifeImage1 {
        width: 90%;
      }
      .lifeinfo {
        flex-direction: column;
        margin-left: 10%;
        width: 40%;
      }
    }
    .TokenInfo {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      min-height: 530px;
      padding: 0 15%;
      background-color: #dffae2;
      .Urban {
        width: 50%;
        display: flex;
        flex-direction: column;
      }
    }
    .Companion {
      width: 100%;
      padding: 0 15%;
      margin: 90px 0 70px 0;

      .CompanionType {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;

        .itemLeft {
          width: 47%;
          margin-top: 80px;
          margin-right: 6%;
        }
        .itemRight {
          margin-top: 80px;
          width: 47%;
        }
      }
    }
    .Faq {
      width: 100%;
      padding: 0;
      margin: 90px 0 70px 0;
      text-align: left;
      h2 {
        font-size: 20px;
        font-family: AvenirNext-DemiBold;
        line-height: 1.3;
        margin-bottom: 24px;
      }
      .faqItem {
        h3 {
          font-size: 18px;
          line-height: 1.3;
          margin-bottom: 4px;
        }
        .metroText {
          font-size: 16px;
          line-height: 1.6;
          width: 100%;
        }
      }
    }
    .text-30 {
      font-size: 26px;
      font-family: AvenirNext-DemiBold;
      line-height: 30px;
    }
    .text-18 {
      font-size: 18px;
      font-family: AvenirNext-Medium;
    }
    .text-35 {
      font-size: 35px;
      font-family: AvenirNext-Bold;
    }
    .metroText {
      width: 95%;
    }
    .des {
      width: 50%;
      font-family: AvenirNext-Bold;
      font-size: 40px;
      font-stretch: normal;
      line-height: 45px;
      color: #131d3d;
      text-align: center;
    }
    .des1 {
      font-family: AvenirNext-Medium;
      font-size: 25px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 30px;
      letter-spacing: 0px;
      color: #131d3d;
      text-align: center;
    }
    .customDes {
      width: 90%;
      font-family: Helvetica;
      font-size: 17px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 25px;
      color: #d4b07b;
      text-align: center;
      margin-top: 77px;
    }

    .download {
      position: relative;
      .store-link {
        display: inline-block;
        line-height: 0;
      }
      img {
        cursor: pointer;
      }
      .android_code {
        position: absolute;
        top: -189px;
        left: 20px;
      }
      .android_stay {
        position: absolute;
        top: -43px;
        left: 0px;
        width: 225px;
        height: 40px;
        background-color: #d5b274;
        border-radius: 3px;
        color: #fff;
        align-items: center;
        justify-content: center;
        display: flex;
      }
      .ios_code {
        position: absolute;
        top: -123px;
        left: 270px;
      }
      .google_code {
        position: absolute;
        top: -189px;
        left: 270px;
      }
      .apple_code {
        position: absolute;
        top: -123px;
        left: 20px;
      }
    }
    .description {
      width: 487px;
      font-family: Helvetica;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 15px;
      letter-spacing: 1px;
      color: #d4b07b;
      font-style: italic;
    }
  }

  .title-35 {
    font-family: Helvetica-Bold;
    font-size: 35px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0px;
    color: #ffffff;
  }
  .hightItem {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 90px;

    .item {
      display: flex;
      flex-direction: row;
      width: 45%;
      margin-right: 10%;
      margin-bottom: 50px;

      &:nth-child(2n) {
        margin-right: 0;
      }
      .iconImage {
        height: 70px;
      }
      .name {
        font-family: Helvetica;
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #d4b07b;
      }
      .description {
        font-family: Helvetica;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #d4b07b;
      }
    }
  }

  &.mobile {
    display: flex !important;
    flex-direction: column !important;
    .footImage {
      width: 100%;
    }
    .logo-link {
      display: inline-block;
      line-height: 0;
    }
    .logoUrl {
      margin-top: 50px;
    }
    .footImage1 {
      width: 80%;
      margin-top: 20px;
    }
    .uptickImage {
      width: 90%;
      margin: 50px 0;
    }
    .footerInfo {
      width: 90%;
      margin: 40px 20px 25px;
    }
    .hightItem {
      .item {
        display: flex;
        flex-direction: row;
        width: 100%;

        margin-bottom: 50px;
      }
    }
    .upwardDes1 {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 0px;
      .topInfo {
        min-height: 650px;
      }

      .des {
        width: 80%;
        text-align: center;
        font-size: 35px;
        line-height: 35px;
      }
      .Lifestyle {
        flex-direction: column;
        margin: 20px 30px;
        padding: 0;
        .lifeinfo {
          width: 80%;
          margin-left: 0;
        }
        .lifeImage {
          width: 90%;
          margin-bottom: 20px;
        }
      }
      .text-30 {
        font-size: 24px;
      }
      .description {
        width: 90%;
        text-align: center;
      }
      .testflight {
        margin-top: 8px;
        margin-left: 0px !important;
      }
      .customDes {
        width: 90%;
      }

      .download {
        display: flex !important;
        flex-direction: column !important;
        align-items: center;
        width: 100%;
        position: relative !important;
      }
      .TokenInfo {
        flex-direction: column;
        padding: 0px;
        .Urban {
          width: 80%;
          margin-right: 0;
          margin-top: 50px;
        }
      }
      .metroText {
        width: 100%;
      }
      .Companion {
        padding: 0;
        width: 80%;
        .CompanionType {
          flex-direction: column;
          .itemLeft {
            width: 100%;
            margin-top: 40px;
          }
          .itemRight {
            width: 100%;
            margin-top: 40px;
          }
        }
      }
      .Faq {
        padding: 0;
        width: 80%;
        margin: 60px auto 40px;
        h2, .faqItem {
          width: 100%;
          margin-left: 0;
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
